/**
 * Bottom edge (px) of the first `header[role="banner"]` in the document.
 * Used to position fixed UI (e.g. user menu drawer) flush under the primary site chrome.
 */
export function readPrimaryBannerBottomPx(): number {
  if (typeof document === 'undefined') return 64;
  const el = document.querySelector('header[role="banner"]');
  if (!el) return 64;
  return Math.max(0, Math.round(el.getBoundingClientRect().bottom));
}
